import { Component, Vue } from 'vue-property-decorator';
import { EventBus } from '@/lib/EventBus';

const createCleanupCallback = (cleanup: any) => (callback: any) => (...args: any) => {
    cleanup();
    callback(...args);
}

@Component({})
export default class Edit extends Vue {
    serverError: string | null = null;
    titleEdit = '';
    formValues: any = {};

    public async save() {
        EventBus.$emit('saveForm');

        return new Promise((resolve, reject) => {
            const cleanup = () => {
                EventBus.$off('form:saved', resolve);
                EventBus.$off('form:error', reject);
            }

            const callWithCleanup = createCleanupCallback(cleanup);

            EventBus.$once('form:saved', callWithCleanup(resolve));
            EventBus.$once('form:error', callWithCleanup(reject));

            this.$once('hook:beforeDestroy', cleanup);
        })
    }
    
    returnBefore() {
        console.log('returnBefore');
    }
}
